<template>
  <main class="splash__container">
    <img class="splash__logo" v-bind:src="logo" width="84" height="100" />
  </main>
</template>

<script>
import logo from '../assets/logo-mobile.svg';

export default {
  name: 'SplashScreen',
  data() {
    return { logo: logo };
  },
  beforeMount() {
    document.body.classList.add('no-scroll');
  },
  beforeDestroy() {
    document.body.classList.remove('no-scroll');
  },
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

::selection {
  background-color: #5ec4bc66;
}

.splash__container {
  background: #0a181b;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.splash__logo {
  animation: splashLogoAnimation 2s ease-in-out infinite;
}

@keyframes splashLogoAnimation {
  0%,
  100% {
    opacity: 1;
    transform: scale(1.05);
  }

  50% {
    opacity: 0;
    transform: scale(1);
  }
}

.splash__wrapper {
  position: relative;
  display: flex;
}

.splash__wrapper > img {
  user-select: none;
}

.splash__wrapper > h4 {
  position: absolute;
  top: 120px;
  left: -36px;
  width: 310px;
  color: #1a3b44;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
}

@media screen and (max-width: 500px) {
  .splash__wrapper > img {
    width: 147px;
  }

  .splash__wrapper > h4 {
    top: 90px;
    left: -81px;
    font-size: 17.5px;
  }
}
</style>
